function AppScreens(){
    return (
        <>
            <section id="how" className="how">
                <div className="sl">Inside the app</div>

                <div className="st">
                    Three screens,<br />
                    total clarity
                </div>

                <div className="screens">
                    {/* Screen 1 */}
                    <div className="screen-item">
                        <div className="screen-mock" style={{ background: "#EF9A9A" }}>


                            <img src="/dashboard03.png"
                                 className="mock-img"
                                 alt={"inaread electricity monitor"} />

                        </div>

                        <h4>Dashboard</h4>
                        <p>Effortlessly understand your usage over time, from daily patterns to monthly trends.</p>
                    </div>

                    {/* Screen 2 */}
                    <div className="screen-item">
                        <div className="screen-mock" style={{ background: "#90CAF9" }}>

                            <img className="mock-img" src="/record_meter.png"
                                 alt={"inaread electricity monitor"} />
                        </div>

                        <h4>Log usage</h4>
                        <p>Log meter readings and add multiple appliances with their ratings in seconds.</p>
                    </div>

                    {/* Screen 3 */}
                    <div className="screen-item">
                        <div className="screen-mock" style={{ background: "#FFF59D" }}>

                            <img className="mock-img" src="/share_report02.png"
                                 alt={"inaread electricity monitor"} />
                        </div>

                        <h4>Share report</h4>
                        <p>
                            Export a beautifully designed summary card and share it across WhatsApp, X or Instagram.
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}

export default AppScreens;
